import mitt, { Emitter } from 'mitt';

type MittInstance = Emitter<{
  OPEN_EASTER_RAFFLE: void;
  GOT_EASTER_EGG_CODE: void;
  REFRESH_CART_TRIGGER_ITEM_COUNT: void;
  OPEN_EASTER_10TH_RAFFLE: void;
}>;

export const mittInstance: MittInstance = mitt();
